import { TextInputMask } from 'react-native-masked-text';
import styled from 'styled-components/native';
import { commonInputStyles } from '~/components/@hello-ui/Input/styles';

export const StyledTextInputMask = styled(TextInputMask).attrs(({ theme, editable }) => ({
  placeholderTextColor: editable ? theme.colors.placeholder : theme.colors['gray-disabled'],
}))`
  ${commonInputStyles}
`;
